import Keycloak from "keycloak-js";

const keycloakConfig = {
  url: "https://login.hs-heilbronn.de",
  realm: "hhn",
  clientId: "hhn_common_scrivito_intranet_visitor",
};

let keycloak = null;
export function getKeycloak() {
  if (typeof window === "undefined") return null;
  if (!keycloak) {
    keycloak = new Keycloak(keycloakConfig);
  }

  return keycloak;
}
